/* =============================================================
   Cirqo Motion — GSAP + ScrollTrigger animation layer
   Depends on: gsap.min.js, ScrollTrigger.min.js (loaded before this file)
   ============================================================= */

(function () {
  'use strict';

  /* ── Guard: GSAP didn't load — reveal everything immediately ── */
  if (typeof gsap === 'undefined') {
    document.querySelectorAll('.cirqo-reveal-up, .cirqo-reveal-left, .cirqo-reveal-right').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  /* ── Animation initializer ─────────────────────────────────────
     Pass `document` for the initial full-page run.
     Pass `event.target` (a section node) for Shopify editor reloads.
     Scoping to a container prevents duplicate triggers on re-runs.
  ─────────────────────────────────────────────────────────────── */
  function initAnimations(root) {
    function find(selector) {
      return Array.from(root.querySelectorAll(selector));
    }

    /* ── 1. SCROLL REVEAL ──────────────────────────────────────── */
    [
      { selector: '.cirqo-reveal-up',    from: { y: 40  }, to: { y: 0  } },
      { selector: '.cirqo-reveal-left',  from: { x: -40 }, to: { x: 0  } },
      { selector: '.cirqo-reveal-right', from: { x: 40  }, to: { x: 0  } },
    ].forEach(function (cfg) {
      find(cfg.selector).forEach(function (el) {
        if (el.closest('.cirqo-stagger')) return;
        gsap.fromTo(
          el,
          Object.assign({ opacity: 0 }, cfg.from),
          Object.assign({ opacity: 1, duration: 0.8, ease: 'power2.out',
            scrollTrigger: { trigger: el, start: 'top 85%' }
          }, cfg.to)
        );
      });
    });

    /* ── 2. STAGGERED SIBLINGS ─────────────────────────────────── */
    find('.cirqo-stagger').forEach(function (parent) {
      var children = parent.querySelectorAll('.cirqo-reveal-up, .cirqo-reveal-left, .cirqo-reveal-right');
      if (!children.length) return;
      gsap.fromTo(
        children,
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', stagger: 0.12,
          scrollTrigger: { trigger: parent, start: 'top 85%' }
        }
      );
    });

    /* ── 3. SCROLL COLUMNS ─────────────────────────────────────── */
    find('.cirqo-cols-scroll').forEach(function (wrap) {
      [{ sel: '.col-2', y: 80 }, { sel: '.col-3', y: 160 }].forEach(function (item) {
        var col = wrap.querySelector(item.sel);
        if (!col) return;
        gsap.fromTo(col,
          { y: item.y },
          { y: 0, ease: 'none',
            scrollTrigger: { trigger: wrap, start: 'top bottom', end: 'bottom top', scrub: 1.5 }
          }
        );
      });
    });

    /* ── 4. WORD REVEAL ────────────────────────────────────────── */
    find('.cirqo-split-text').forEach(function (el) {
      var words = el.innerText.trim().split(/\s+/);
      el.innerHTML = words.map(function (w) {
        return '<span style="display:inline-block;overflow:hidden;margin-right:0.25em">' +
               '<span class="cirqo-word-inner" style="display:inline-block">' + w + '</span>' +
               '</span>';
      }).join('');
      gsap.fromTo(
        el.querySelectorAll('.cirqo-word-inner'),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', stagger: 0.05,
          scrollTrigger: { trigger: el, start: 'top 88%' }
        }
      );
    });

    /* ── 5. PARALLAX ───────────────────────────────────────────── */
    find('.cirqo-parallax').forEach(function (wrapper) {
      var img = wrapper.querySelector('.cirqo-parallax-img');
      if (!img) return;
      var shift = wrapper.offsetHeight * 0.3;
      gsap.fromTo(img,
        { y: -shift },
        { y: shift, ease: 'none',
          scrollTrigger: { trigger: wrapper, start: 'top bottom', end: 'bottom top', scrub: true }
        }
      );
    });

    /* ── 6. NUMBER COUNT-UP ────────────────────────────────────── */
    find('[data-countup]').forEach(function (el) {
      var target = parseFloat(el.dataset.countup);
      if (isNaN(target)) return;
      var isInt = Number.isInteger(target);
      var counter = { val: 0 };
      gsap.to(counter, {
        val: target, duration: 1.5, ease: 'power2.out',
        onUpdate: function () {
          el.textContent = isInt
            ? Math.round(counter.val).toLocaleString()
            : counter.val.toFixed(1);
        },
        scrollTrigger: { trigger: el, start: 'top 85%', once: true },
      });
    });

    /* ── 7. VIDEO AUTOPLAY ON SCROLL ───────────────────────────── */
    find('.cirqo-video-trigger').forEach(function (video) {
      ScrollTrigger.create({
        trigger: video, start: 'top 70%', end: 'bottom 30%',
        onEnter:     function () { video.play && video.play().catch(function () {}); },
        onLeave:     function () { video.pause && video.pause(); },
        onEnterBack: function () { video.play && video.play().catch(function () {}); },
        onLeaveBack: function () { video.pause && video.pause(); },
      });
    });
  }

  /* ── STICKY NAV (document-level, runs once) ──────────────────── */
  var stickyHeader = document.querySelector('header');
  if (stickyHeader) {
    ScrollTrigger.create({
      start: 80,
      onEnter: function () {
        Object.assign(stickyHeader.style, {
          backdropFilter: 'blur(14px)',
          background:     'rgba(26,26,26,0.9)',
          borderBottom:   '0.5px solid rgba(221,211,188,0.1)',
          transition:     'all 0.3s ease',
        });
      },
      onLeaveBack: function () {
        Object.assign(stickyHeader.style, {
          backdropFilter: '',
          background:     '',
          borderBottom:   '',
        });
      },
    });
  }

  /* ── INITIAL RUN ─────────────────────────────────────────────── */
  initAnimations(document);

  /* ── SHOPIFY THEME EDITOR: re-run on section reload ─────────────
     Fired whenever the editor re-renders a section (setting change,
     section add, block reorder, etc.). Without this, every element
     that carries .cirqo-reveal-up stays at opacity:0 after an edit.
  ─────────────────────────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', function (event) {
    /* Kill stale ScrollTrigger instances whose triggers no longer exist */
    ScrollTrigger.getAll().forEach(function (st) {
      if (st.trigger && !document.contains(st.trigger)) st.kill();
    });
    initAnimations(event.target);
    ScrollTrigger.refresh();
  });

})();
